"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SecurityContextHolder = require("../../api/SecurityContextHolder");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const WelcomeMessage = _ref => {
  let {
    isDesktop,
    customWelcome
  } = _ref;
  let welcome = 'Welcome';
  const user = _SecurityContextHolder.SecurityContextHolder.getCurrentContext();
  const isAuthenticated = _SecurityContextHolder.SecurityContextHolder.getCurrentContext();
  if (typeof user !== 'undefined' && isAuthenticated) {
    if (user.firstName && user.lastName) {
      welcome += `, ${user.firstName} ${user.lastName}`;
    } else if (user.firstName) {
      welcome += `, ${user.firstName}`;
    } else if (user.lastName) {
      welcome += `, ${user.lastName}`;
    }
    welcome += user?.impersonator ? ` [${user.impersonator.firstName} ${user.impersonator.lastName}]` : '';
    if (isDesktop) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "is-hidden-desktop welcome-user"
      }, customWelcome || welcome);
    }
    if (customWelcome) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "navbar-start is-hidden-touch"
      }, customWelcome);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "navbar-start is-hidden-touch"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "navbar-item welcome-message"
    }, welcome));
  }
  if (customWelcome) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "navbar-start is-hidden-touch"
    }, customWelcome);
  }
  return null;
};
WelcomeMessage.propTypes = {
  isDesktop: _propTypes.default.bool.isRequired,
  customWelcome: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object])
};
var _default = exports.default = WelcomeMessage;
//# sourceMappingURL=WelcomeMessage.js.map